// extracted by mini-css-extract-plugin
module.exports = {"switchPageBtn":"switchpageitem_switchPageBtn__1MnQs","xs":"switchpageitem_xs__3JWAU"};